export default __webpack_public_path__ + "static/media/hand-with-chocolate.df62e9a5.png";